<template>
  <LPopup>
    <h3>{{ name }}</h3>
    <div v-if="phone">
      <FontAwesomeIcon :icon="['far', 'phone']"/>
      {{ phone | formatPhone }}
    </div>
    <router-link
      :to="`/location/${slug}/${id}`"
      data-testid="popupLink">
      View details
    </router-link>
  </LPopup>
</template>

<script>
import { LPopup } from 'vue2-leaflet'
import { formatPhone } from '~/util'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue';
Vue.component('font-awesome-icon', FontAwesomeIcon)

export default {
  components: {
    LPopup,
    FontAwesomeIcon
  },
  filters: {
    formatPhone
  },
  props: {
    id: {
      type: String,
      required: true,
      default: ''
    },
    slug: {
      type: String,
      required: true,
      default: ''
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    phone: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LocationMarkerPopup.vue